import * as React from "react";
import { useIntl } from "react-intl";
import { graphql, useStaticQuery } from "gatsby";
import Close from "./close";
import Link from "./link";
import Logo from "./logo";
import SocialNetworks from "./social-networks";
import Languages from "./languages";
import FullNav from "./full-nav";
import GoogleRating from "./google-rating";

const query = graphql`
  query {
    allContentfulHome {
      nodes {
        node_locale
        burgerMenuText
        burgerMenuTextLink {
          button
          link
          id
          title
          target
          textColour
        }
      }
    }
  }
`;

const Menu = ({ menu, handleClick }) => {
  const { allContentfulHome } = useStaticQuery(query);
  const { locale } = useIntl();

  const { burgerMenuText, burgerMenuTextLink } = allContentfulHome.nodes.find(
    ({ node_locale }) => node_locale === locale
  );

  return (
    <div
      id="menu"
      className="header-menu"
      role={menu ? "dialog" : undefined}
      aria-modal={menu ? "true" : undefined}
      tabIndex={-1}
      aria-label="Menu"
    >
      <button onClick={handleClick}>
        <Close />
      </button>
      <div className="container">
        <div className="header-intro">
          <div>
            <Link href="/" onClick={handleClick}>
              <Logo />
            </Link>
            <p className="h2">{burgerMenuText}</p>
            <Link
              href={burgerMenuTextLink.link}
              className="menu-link"
              onClick={handleClick}
            >
              {burgerMenuTextLink.title}
            </Link>
            <GoogleRating />
          </div>
        </div>
        <div className="header-full-nav">
          <div className="header-full-nav-top">
            <SocialNetworks />
            <Languages handleClick={handleClick} />
          </div>
          <GoogleRating />
          <div className="header-full-nav-intro">
            <p className="h2">{burgerMenuText}</p>
            <Link
              href={burgerMenuTextLink.link}
              className="menu-link"
              onClick={handleClick}
            >
              {burgerMenuTextLink.title}
            </Link>
          </div>
          <FullNav handleClick={handleClick} />
        </div>
      </div>
    </div>
  );
};

export default Menu;
